export default __webpack_public_path__ + "static/media/Velocity-Home_08.129c7711.jpg";